import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Card,
  Flex,
  Page,
} from '../../components';

const propTypes = {
  title: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  submit: PropTypes.func.isRequired,
  render: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]).isRequired,
  notifier: PropTypes.shape({
    text: PropTypes.string,
    colorVariant: PropTypes.string,
  }),
};

const defaultProps = {
  notifier: undefined,
  loading: false,
};

function Features({
  title, render, loading, submit, notifier,
}) {
  return (
    <Page title={title} notifier={notifier}>
      <Card loading={loading}>
        <Card.Block>
          <form onSubmit={submit}>
            {render}
            {Array.isArray(render)
              && (
                <Flex>
                  <Flex.Item marginStart="auto">
                    <Button primary type="submit">Save</Button>
                  </Flex.Item>
                </Flex>
              )
            }
          </form>
        </Card.Block>
      </Card>
    </Page>
  );
}
Features.propTypes = propTypes;
Features.defaultProps = defaultProps;
export default Features;
